import {useTranslation} from 'react-i18next';
import {AddFormType} from 'context/guest';
import {groupByGroupName} from './utils/groupByGroupName';
import {useGuestGroup} from 'hooks';
import {useLayoutMode} from 'hooks/useLayoutMode';
import type {FormFieldsMapper} from './types';
import {CustomField} from './CustomField';
import {DefaultField} from './DefaultField';
import {FieldsGroup} from 'components/FieldsGroup';
import {FieldsGroupVariant} from 'components/FieldsGroup/styled';
import {GUEST_FORM_NAMES} from '@chekin/core';
import ChekinProSettings from 'ChekinProSettings';

type Props = {
  defaultFieldsMapper: FormFieldsMapper;
  formFields: AddFormType;
  isDisabled?: boolean;
  variant?: FieldsGroupVariant;
};
export const GroupedFields = ({
  defaultFieldsMapper,
  formFields,
  isDisabled,
  variant = 'default',
}: Props) => {
  const {t} = useTranslation();
  const {isLeaderGuest} = useGuestGroup();
  const layoutMode = useLayoutMode();
  const groups = groupByGroupName(formFields, defaultFieldsMapper, isLeaderGuest);

  return groups.map((group, index) => (
    <FieldsGroup
      title={group.title}
      key={index}
      withWhyDataRequired={
        index === 0 &&
        layoutMode === 'default' &&
        ChekinProSettings.appVariant !== 'airbnb'
      }
      variant={variant}
    >
      {group.fields.map(field =>
        field.is_custom ? (
          <CustomField
            key={field.name}
            field={field}
            disabled={isDisabled}
            required={field.is_required ? t('this_field_is_required') : false}
          />
        ) : (
          <DefaultField
            key={field.name}
            formFieldsMapper={defaultFieldsMapper}
            fieldName={field.name as GUEST_FORM_NAMES}
            formFields={formFields}
          />
        ),
      )}
    </FieldsGroup>
  ));
};
